/**
 * gat-flower-cart-stock.js
 * Caps minicart + button at remaining 3.5g stock
 * Uses the theme cart-item error message
 */

(function () {
  'use strict';

  function findCartItemEl(key, btn) {
    return document.getElementById('minicart__product-' + key) ||
           (btn && btn.closest('.cart-item')) ||
           null;
  }

  function showItemError(itemEl, message) {
    if (!itemEl) return;

    var errorText = itemEl.querySelector('.cart-item__error-text');
    var errorWrap = itemEl.querySelector('.cart-item__error');

    if (errorText) errorText.textContent = message;
    if (errorWrap) {
      errorWrap.classList.remove('hidden', 'invisible', 'd-none');
      errorWrap.style.display = '';
    }
  }

  function handlePlusClick(e) {
    var btn = e.target.closest('button[name="plus"], .quantity__button[name="plus"]');
    if (!btn) return;
    if (!btn.closest('#minicart-form, .minicart, cart-notification')) return;

    var key = btn.getAttribute('data-id');
    var itemEl = findCartItemEl(key, btn);
    if (!itemEl || itemEl.getAttribute('data-gat-flower') !== 'true') return;

    var max = parseInt(itemEl.getAttribute('data-gat-max'), 10);
    if (isNaN(max)) return;

    var input = itemEl.querySelector('input.quantity-input, input[name="updates[]"]');
    var current = input ? parseInt(input.value, 10) : NaN;
    if (isNaN(current)) return;

    if (current + 1 > max) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showItemError(itemEl, 'Only ' + max + ' x 3.5g left in stock');
      input.value = current;
    }
  }

  function init() {
    document.removeEventListener('click', handlePlusClick, true);
    document.addEventListener('click', handlePlusClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();